module.exports = __webpack_public_path__ + "img/canoninverted.31bb005c.svg";